import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import isMeetingOnPublicCalendar from '../../utils/isMeetingOnPublicCalendar';
import type { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';
import { isNewCalendarMeeting } from 'owa-calendar-event-capabilities';

/**
 * These is based on the meeting being created in a Public folder or not
 *  @param event : The subject event
 *
 */
export default (event: CalendarEvent): InfoBarMessageViewState[] =>
    isMeetingOnPublicCalendar(event) && isNewCalendarMeeting(event)
        ? [InfoBarViewStates.getErrorCannotCreatePublicFolderMeetings()]
        : [];
